/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createJobResponseFromDiscriminatorValue, serializeCreateVideoAudioEditJobRequest, serializeJobResponse, type CreateVideoAudioEditJobRequest, type HttpValidationProblemDetails, type IError, type JobResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type UploadsRequestBuilder, UploadsRequestBuilderNavigationMetadata } from './uploads/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/audio
 */
export interface AudioRequestBuilder extends BaseRequestBuilder<AudioRequestBuilder> {
    /**
     * The uploads property
     */
    get uploads(): UploadsRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CreateVideoAudioEditJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateVideoAudioEditJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AudioRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/audio";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AudioRequestBuilderNavigationMetadata: Record<Exclude<keyof AudioRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    uploads: {
        navigationMetadata: UploadsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AudioRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AudioRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateVideoAudioEditJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
